







































































































import {Vue, Component} from 'vue-property-decorator';
import {GetProductImage} from 'supporter';
import ImageArea from '@/components/product/ProductListImageArea.vue';
import {uploadFile} from '@/utils/commonUtils';
import editor from '@/components/common/summernote/Index.vue';
import {toI18n} from '@/utils/commonUtils';
import { MAX_ADDABLE_UPLOAD_IMAGE_COUNT } from '@/const/product';

@Component({
  components: {
    ImageArea,
    editor
  }
})
export default class EditImages extends Vue {
  public toI18n(needToI18nStr: string, param?: Record<string, string|number>): string {
    return toI18n(this.$t(`PRODUCT_POP_PRODUCTLIST_${needToI18nStr}`, param));
  }

  public readonly MAX_ADDABLE_UPLOAD_IMAGE_COUNT = MAX_ADDABLE_UPLOAD_IMAGE_COUNT;

  private optionsUp = {
    height: 250,
    width: 750,
    imageFileSize: 5120
  };

  private optionsMiddle = {
    height: 250,
    width: 750,
    imageFileSize: 10240
  };

  private optionsDown = {
    height: 250,
    width: 750,
    imageFileSize: 5120
  };

  private pageInfo: GetProductImage = {
    productImages: [
      {
        imageUrl: '',
        symbolic: false,
        originImageUrl: null,
        displayOrder: 0
      }
    ],
    listImageUrl: '',
    usesRegisteredOptionImages: false,
    content: {
      header: '',
      detail: '',
      footer: ''
    },
    hasOptionImage: false
  };

  private radiosVal = {
    contentHeaderYn: 'N',
    addOptionImageYn: 'Y',
    contentFooterYn: 'N'
  };

  private isMainImageExist = true;
  private isHeaderContentExist = true;
  private isDetailContentExist = true;
  private isFooterContentExist = true;

  private editorVal = {
    header: '',
    detail: '',
    footer: ''
  };

  get listImageIsShow() {
    return this.pageInfo.listImageUrl && this.pageInfo.listImageUrl.length ? 'display: block' : 'display: none;';
  }

  get mallNo() {
    return this.$route.params.mallNo;
  }

  get disable() {
    return this.$route.params.readOnly === 'true' ? true : false;
  }

  private editorOnChange({html, editorId}: {html: string; editorId: string}): void {
    switch (editorId) {
      case 'header':
        this.isHeaderContentExist = true;
        break;
      case 'detail':
        this.isDetailContentExist = true;
        break;
      case 'footer':
        this.isFooterContentExist = true;
        break;
    }
    Object.assign(this.editorVal, {[editorId]: html});
  }

  private openUploadDialog() {
    const fileInput = this.$refs.listImage as any;
    fileInput.value = '';
    fileInput.click();
  }

  private uploadImage(e: any) {
    const files = e.target.files || e.dataTransfer.files;
    const fileType = Object.values(files).map((file: any): any => ['image/png', 'image/jpeg', 'image/gif', 'image/bmp'].includes(file.type));

    if (fileType.includes(false)) {
      alert(this.toI18n('EIMAGEMSG1')); //이미지파일(Jpg,jpge,gif,png,bmp)만 등록해주세요.
      (this.$refs.productImage as any).value = '';
      return;
    }

    const fileSize = Object.values(files).map((file: any): any => Math.ceil(file.size / 1024) > 1024 * MAX_ADDABLE_UPLOAD_IMAGE_COUNT);
    if (fileSize.includes(true)) {
      alert(window.$t('COMMON_FILE_SIZE_ERR_IMG', [`${MAX_ADDABLE_UPLOAD_IMAGE_COUNT}M`]));
      return;
    }

    uploadFile(files, this.mallNo).then(
      ([
        {
          data: {url: listImageUrl}
        }
      ]: any) => {
        Object.assign(this.pageInfo, {listImageUrl});
      }
    );
  }
  private remove() {
    this.pageInfo.listImageUrl = '';
  }

  private close() {
    window.close();
  }

  private addOptionImageYnChange() {
    if (!this.pageInfo.hasOptionImage) {
      this.$nextTick(() => {
        this.pageInfo.content.detail ? (this.radiosVal.addOptionImageYn = 'N') : (this.radiosVal.addOptionImageYn = 'Y');
      });
      alert(this.toI18n('EIMAGEMSG2')); //해당 상품에 등록된 옵션 이미지가 없습니다.
    }
  }

  private mainImgUploaded() {
    this.isMainImageExist = true;
  }

  private contentFooterChange() {
    if (this.radiosVal.contentFooterYn === 'N') {
      this.isFooterContentExist = true;
    }
  }

  private save() {
    const params = {
      mallProductNo: this.$route.params.mallProductNo
    };

    const data: any = {
      contentHeader: this.radiosVal.contentHeaderYn === 'Y' ? this.editorVal.header : '',
      content: this.radiosVal.addOptionImageYn === 'N' ? this.editorVal.detail : '',
      contentFooter: this.radiosVal.contentFooterYn === 'Y' ? this.editorVal.footer : '',
      addOptionImageYn: this.radiosVal.addOptionImageYn,
      mallProductListImage: this.pageInfo.listImageUrl,
      mallProductImages: [],
      mallNo: this.mallNo
    };
    const mallProductImages = (this.$refs.imagesList as any).imageData();
    if (!mallProductImages.find((imgInfo: any) => imgInfo.mainYn === 'Y')) {
      this.isMainImageExist = false;
    }

    if (this.radiosVal.contentHeaderYn === 'Y' && !data.contentHeader) {
      this.isHeaderContentExist = false;
    }

    if (this.radiosVal.addOptionImageYn === 'N' && !data.content) {
      this.isDetailContentExist = false;
    }

    if (this.radiosVal.contentFooterYn === 'Y' && !data.contentFooter) {
      this.isFooterContentExist = false;
    }
    if (!this.isHeaderContentExist || !this.isDetailContentExist || !this.isFooterContentExist || !this.isMainImageExist) {
      alert(this.toI18n('EIMAGEMSG3')); //입력 불가한 항목이 있습니다. 다시확인해주세요.
      return false;
    }
    if (this.radiosVal.contentHeaderYn === 'N') {
      delete data.contentHeader;
    }

    if (this.radiosVal.addOptionImageYn === 'Y') {
      delete data.content;
    }

    if (this.radiosVal.contentFooterYn === 'N') {
      delete data.contentFooter;
    }

    Object.assign(data, {mallProductImages});

    this.$api
      .patchProductImage({params, data})
      .then(() => {
        alert(this.toI18n('EIMAGEMSG4')); //이미지 정보 수정이 완료되었습니다.
        this.close();
      })
      .catch(() => {
        alert(this.toI18n('EIMAGEMSG5')); //이미지 정보 수정이 실패했습니다.
      });
  }

  private created() {
    document.body.classList.add('popup', 'popup_large');
    const params = {
      productNo: this.$route.params.mallProductNo
    };
    this.$api.getProductImage({params}).then(({data}: any) => {
      this.pageInfo = Object.assign({}, data);

      this.pageInfo.content.header ? (this.radiosVal.contentHeaderYn = 'Y') : (this.radiosVal.contentHeaderYn = 'N');
      this.pageInfo.usesRegisteredOptionImages ? (this.radiosVal.addOptionImageYn = 'Y') : (this.radiosVal.addOptionImageYn = 'N');
      this.pageInfo.content.footer ? (this.radiosVal.contentFooterYn = 'Y') : (this.radiosVal.contentFooterYn = 'N');

      Object.assign(this.editorVal, {...this.pageInfo.content});
      setTimeout((): void => {
        window.scrollTo(0, 0);
      });
    });

    window.name = 'imageUrlWin';
  }
}
